import { useContext } from 'react'
import { ToastifyContext } from '../contexts/ToastifyContext'

export const useToastify = () => useContext(ToastifyContext)

